// export const SERVER_URL = 'https://prisha-fashion.onrender.com';
export const SERVER_URL = 'https://newecom-bsdj.vercel.app';
export const PRISHA_FRONTEND_URL = 'http://localhost:3000'
